import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import { fetchDisplayRoleName } from '../../stores/Administrators/AdministratorModalStore';
import ConsoleStore from '../../stores/ConsoleStore';
import ChangePasswordStore from '../../stores/ChangePasswordStore';
import Button from '../Button';
import { TextWithTitle } from '../ConsoleFragments';
import Dropdown from '../Dropdown';
import { FTCaption, FTInput, FTBody, FTLabel } from '../Fuse';
import { Key } from '../../mirror/userInput';
import './FuseUserMenu.css';

const block = b.lock('FuseUserMenu');

class FuseUserMenu extends Component {
    static propTypes = {
        console: ConsoleStore.PropType.isRequired,
        changePassword: ChangePasswordStore.PropType.isRequired,
    };

    state = {
        items: [],
        index: -1,
    };

    constructor(props) {
        super(props);

        this.containerRef = React.createRef();
    }

    componentDidMount() {
        this.containerRef.current.focus();
        this.initItems(this.props.console.isSSOUser);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.console.isSSOUser !== nextProps.console.isSSOUser) {
            this.initItems(nextProps.console.isSSOUser);
        }
    }

    initItems = (isSSOUser) => {
        const items = [];
        if (!isSSOUser) {
            items.push({
                label: 'Change Password…',
                icon: 'outline_lock',
                action: this.props.changePassword.modal.toggle,
            });
        }
        items.push({
            label: 'Log Out',
            icon: 'logout',
            action: this.props.console.logout,
        });
        this.setState({ items });
    };

    onKeyDown = (e) => {
        let { index } = this.state;
        if (e.keyCode === Key.DOWN) {
            index = this.state.items.length > (index + 1) ? index + 1 : index;
        }
        if (e.keyCode === Key.UP) {
            index = index - 1 < 0 ? index : index - 1;
        }

        if (e.keyCode === Key.SPACE || e.keyCode === Key.ENTER) {
            this.state.items[this.state.index].action();
        }

        if (e.keyCode === Key.ESC) {
            this.props.console.userMenu.close();
        }
        this.setState({ index });
    };

    render() {
        return <Dropdown
            className={block()}
            onClose={this.props.console.userMenu.close}
            onKeyDown={this.onKeyDown}
        >
            <div
                className={block('Content')}
                ref={this.containerRef}
                tabIndex={-1}
            >
                <div className={block('ContentHeader')}>
                    <FTLabel style={{ marginBottom: 4 }}>Administrator</FTLabel>
                    {this.props.console.userName ? <FTBody className={block('UserName')}>
                        <TextWithTitle text={this.props.console.userName} />
                    </FTBody> : null}
                    <FTCaption className={block('UserEmail')}>
                        <TextWithTitle text={this.props.console.userEmail} />
                    </FTCaption>
                </div>
                <div className={block('ContentHeader')}>
                    <FTLabel style={{ marginBottom: 4 }}>Admin Role</FTLabel>
                    <FTBody>{fetchDisplayRoleName(this.props.console.authority)}</FTBody>
                </div>
                <div className={block('Actions')}>
                    {this.state.items.map(({ label, icon, action }, idx) => <Button
                        className={block('Item', { selected: idx === this.state.index })}
                        key={label}
                        icon={icon}
                        onClick={action}
                        noCenter
                        name={label}
                    ><FTInput>{label}</FTInput></Button>)}
                </div>
            </div>
        </Dropdown>;
    }
}

export default inject('console', 'changePassword')(observer(FuseUserMenu));
